import EmptyTableRow from "../../../../common/EmptyTableRow";
import React from "react";
import {OrdersDetailPtaType} from "../interface";

interface PropsType {
    ordersPta: OrdersDetailPtaType
}

export default function Tab3({ordersPta}: PropsType) {
    return <div className="content_wrap">
        <h5 className="subheading mt-0">PTA 정보</h5>
        <div className="table_scroll mt-0">
            <table className="table table-bordered my_table table_detail">
                <tbody>
                <tr>
                    <th style={{width: "16.66%"}}>CLA Number</th>
                    <td>{ordersPta.claNumber}</td>
                    <th style={{width: "16.66%"}}>CompanyID</th>
                    <td>{ordersPta.companyId}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <div className="table_top">
            <h6 className="table_stats">
                PTA 이력(<span>{ordersPta.ptaList.length ?? 0}</span>건)
            </h6>
            <div className="table_toolbar"></div>
        </div>
        <div className="table_scroll mb-0">
            <table className="table table-bordered my_table">
                <thead>
                <tr>
                    <th style={{width: "5%"}}>No</th>
                    <th style={{width: "25%"}}>기준</th>
                    <th style={{width: "40%"}}>Pricing Group</th>
                    <th style={{width: "15%"}}>Pricing Tier</th>
                    <th style={{width: "15%"}}>ERP코드</th>
                </tr>
                </thead>
                <tbody>
                {ordersPta.ptaList.length !== 0 ?
                    ordersPta.ptaList.map((item, index) =>
                        <tr key={index}>
                            <td className="text-center">{index + 1}</td>
                            <td className="text-center">{item.standard}</td>
                            <td className="text-center">{item.pricingGroup}</td>
                            <td className="text-center">{item.priceTier}</td>
                            <td className="text-center">{item.erpCode}</td>
                        </tr>
                    )
                    : <EmptyTableRow colSpan={5}/>}
                </tbody>
            </table>
        </div>
    </div>
}